export const defaultTabFilters = {
  unassigned: '&q[assignment_eligible_for_carrier]=1',
  dispatched: '&q[dispatch_for_carrier]=1',
  'in-transit': '&q[transit_for_carrier]=1',
  completed: '&q[completed_for_carrier]=1',
};

export const defaultTabSort = {
  unassigned: 'origin_asc',
  dispatch: 'origin_asc',
  'in-transit': 'origin_asc',
  completed: 'origin_asc',
};

export const defaultPagination = {
  totalRecords: 0,
  totalPages: 0,
  currentPage: 1,
};

export const defaultFilterValues = {
  loadId: '',
  originInput: '',
  origin_state: '',
  origin_zip: '',
  // origin: '',
  // originType: '',
  destinationInput: '',
  destination_state: '',
  destination_zip: '',
  // destination: '',
  // destinationType: '',
  pickup: '',
  delivery: '',
  pickupStart: '',
  pickupEnd: '',
  deliveryStart: '',
  deliveryEnd: '',
  pickupCalendarStartDate: '',
  brokerId: '',
  brokerName: '',
  equipment: [],
};

export const sortParamLookup = {
  origin: {
    title: 'Ascending by Origin',
    query: 'start_stop_scheduled_window_started_at+asc',
  },
  destination: {
    title: 'Ascending by Destination',
    query: 'start_stop_scheduled_window_started_at+desc',
  },
  origin_asc: {
    title: 'Ascending by Origin',
    query: 'start_stop_scheduled_window_started_at+asc',
  },
  origin_desc: {
    title: 'Descending by Origin',
    query: 'start_stop_scheduled_window_started_at+desc',
  },
  destination_asc: {
    title: 'Ascending by Destination',
    query: 'end_stop_scheduled_window_started_at+asc',
  },
  destination_desc: {
    title: 'Descending by Destination',
    query: 'end_stop_scheduled_window_started_at+desc',
  },
  posting_asc: {
    title: 'Ascending by Load Posting',
    query: 'last_posted_at+asc',
  },
  posting_desc: {
    title: 'Descending by Load Posting',
    query: 'last_posted_at+desc',
  },
};

export const filterParamLookup = {
  // TODO --
  // origin: {
  //   title: 'Filter by Origin',
  //   query: '&q[origin_area_id]',
  // },
  // destination: {
  //   title: 'Filter by Destination',
  //   query: '&q[destination_area_id]',
  // },
  originState: {
    title: 'Filter by Origin State',
    query: '&q[start_stop_state_eq]=',
  },
  destinationState: {
    title: 'Filter by Destination State',
    query: '&q[end_stop_state_eq]=',
  },
  originZip: {
    title: 'Filter by Origin Zipcode',
    query: '&q[start_stop_postal_code_eq]=',
  },
  destinationZip: {
    title: 'Filter by Destination Zipcode',
    query: '&q[end_stop_postal_code_eq]=',
  },
  pickup: {
    title: 'Filter by origin',
    query: '&q[start_stop_scheduled_window_started_at_date_eq]=',
  },
  dropoff: {
    title: 'Filter by destination',
    query: '&q[end_stop_scheduled_window_started_at_date_eq]=',
  },
  pickup_start: {
    title: 'Filter by origin',
    query: '&q[start_stop_scheduled_window_started_at_date_gteq]=',
  },
  pickup_end: {
    title: 'Filter by origin',
    query: '&q[start_stop_scheduled_window_started_at_date_lteq]=',
  },
  dropoff_start: {
    title: 'Filter by destination',
    query: '&q[end_stop_scheduled_window_started_at_date_gteq]=',
  },
  dropoff_end: {
    title: 'Filter by destination',
    query: '&q[end_stop_scheduled_window_started_at_date_lteq]=',
  },
  equipment: {
    title: 'Filter by equipment',
    query: '&q[equipment_type_in][]=',
  },
  trailer: {
    title: 'Filter by trailer type',
    query: '&q[equipment_type_in][]=',
  },
  load: {
    title: 'Filter by load type',
    query: '&q[equipment_type_in][]=',
  },
  loadId: {
    title: 'Filter by load ID',
    query: '&q[single_external_load_number_equals]=',
  },
  brokerId: {
    title: 'Filter by broker ID',
    query: '&q[company_id_eq]=',
  },
  // TODO -- update queries below, add posting
  // origin_deadhead: {
  //   title: 'Filter by deadhead',
  //   query: '&q[weight_eq]',
  // },
  // destination_deadhead: {
  //   title: 'Filter by deadhead',
  //   query: '&q[weight_eq]',
  // },
  rate: {
    title: 'Filter by rate',
    query: '&q[rate_type_in][]=',
  },
  min_rate: {
    title: 'Filter by minimum rate',
    query: '&q[min_rate_gteq]=',
  },
  posted_at_start: {
    title: 'Filter by Posted age',
    query: '&q[last_posted_at_gteq]=',
  },
  posted_at_end: {
    title: 'Filter by Posted age',
    query: '&q[last_posted_at_lteq]=',
  },
};
